import React from "react";
import PropTypes from "prop-types";
import { createSlice } from "@reduxjs/toolkit";
import {
  ResultError,
  ResultInfo,
  ResultSubtract,
  ResultSuccess,
} from "@/ImageRepo";

// Default initial state for Alert slice if not provided
//const initialState = {
//    status: null,
//    singleLine: true,
//    title: null,
//    message: "default",
//    link: null,
//    buttonLabel: null,
//    showAlert: true,
//};

const alertSlice =
  // Implement createSlice method and export actions and reducer for ShepAlert
  createSlice({
    name: "alert",
    initialState: {
      alerts: [], // array that holds ShepAlert objects whenever an alert action is dispatched
    },
    reducers: {
      // Adds new alert action to the array whenever an alert action is dispatched
      createAlert: (state, action) => {
        const {
          status,
          alertType,
          title,
          message,
          link,
          buttonLabel,
          showAlert,
          onButtonClick,
          buttonLabel2,
          onButtonClick2,
          onClose,
          intValue,
          setIntValue
        } = action.payload;

        let newAlert = {
          status: status,
          alertType: alertType,
          title: title,
          message: message,
          link: link,
          buttonLabel: buttonLabel,
          showAlert: showAlert,
          onButtonClick: onButtonClick,
          buttonLabel2: buttonLabel2,
          onButtonClick2: onButtonClick2,
          onClose: onClose,
          intValue: intValue,
          setIntValue: setIntValue
        };

            state.alerts.push(newAlert);
            //console.debug(
            //  "Created alert " + state.alerts.length + ":",
            //  state.alerts[state.alerts.length - 1]
            //);

        return state;
      },
      removeAlert: (state, action) => {
        const alertList = state.alerts.filter((alert, i) => i !== action.id);
        console.debug("Removing alert", action.id);
        return {
          ...state,
          alerts: alertList,
        };
      },
      // Hide the alert when close button clicked
      onAlertClose: (state, action) => {
        state.showAlert = false;
        console.log("close button clicked" + state.showAlert);
        const alertList = state.alerts.filter((alert, i) => i !== action.id);
        return {
          ...state,
          alerts: alertList,
        };
      },
      setIsAlertVisible: (state, action) => {
        const { showAlert } = action.payload;
        state.showAlert = showAlert;
        console.log("Alert visibility: " + state.showAlert);
        return state;
      },
      onButtonClick: (state, action) => {
          const { value } = action.payload;
          console.log("button click");
      },
      onClose: (state, action) => {
        const { value } = action.payload;
      },
      updateAlertType: (state, action) => {
        const { status, title, message } = action.payload;
        state.status = status;
        state.title = title;
        state.message = message;
        state.icon = renderIcon();
      },
    },
    selectors: {
      selectAlertStatus: (state) => {
        console.log("alert status currently: " + state.showAlert);
        return state.showAlert;
      },
    },
  });

// Set the icon type based on status
const renderIcon = (status) => {
  switch (status) {
    case "Success":
      return <ResultSuccess className="status-icon" />;
    case "Warning":
      return <ResultSubtract className="status-icon" />;
    case "Error":
      return <ResultError className="status-icon" />;
    case "Info":
      return <ResultInfo className="status-icon" />;
    default:
      return null;
  }
};

export const selectAlerts = (state) => state.tempInfo.sendAlert;
export const selectAllAlerts = (state) => state.tempInfo.sendAlert.alerts;
export const { createAlert, removeAlert } = alertSlice.actions;
export default alertSlice;
